import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';
import { serviceShape } from '../../shapes';
import ServiceDetails from './ServiceDetails';
import { nullFunc } from '../../utils/helpers';


const Service = ({ service, generateUrlString, onClick }) => (
  <Link
    rel="nofollow"
    onClick={onClick}
    className={classnames(
      'c-select-box c-select-box--small c-select-box--no-hover',
      'u-text-center u-bg-black-2',
      { 'is-active': service.selected }
    )}
    to={generateUrlString(service.id)}
  >
    <ServiceDetails service={service} />
  </Link>
);
Service.propTypes = {
  service: serviceShape.isRequired,
  generateUrlString: PropTypes.func,
  onClick: PropTypes.func,
};
Service.defaultProps = {
  generateUrlString: nullFunc,
  onClick: nullFunc,
};
export default Service;



// WEBPACK FOOTER //
// ./src/app/services/components/Service.jsx